import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/legal/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="mx-auto max-w-4xl px-6 py-16 lg:px-8 lg:py-24">
      <h1 className="mb-8 font-display text-4xl font-semibold tracking-tight text-black md:text-5xl">
        Legal
      </h1>
      
      <div className="space-y-6">
        <Link 
          to="/legal/privacy-policy" 
          className="block rounded-lg border border-black/10 bg-gray-50 p-6 transition-all hover:border-black/20 hover:bg-gray-100"
        >
          <h2 className="mb-2 text-2xl font-semibold text-black">Privacy Policy</h2>
          <p className="text-black/60">
            Learn how we collect, use, and protect your personal data.
          </p>
        </Link>
      </div>
    </div>
  )
}
